export default "__VITE_ASSET__6cjQ0Kqb__"